import { GinnyPal, PatchPal, VinylPal } from "src/static/img";

export const PAL_FIELD_SLUG = "apps_assigned_hacker_pal_number";

export const GINNY_NUMBER = 1;
export const PATCH_NUMBER = 2;
export const VINYL_NUMBER = 3;
export type TPalOption =
  | typeof GINNY_NUMBER
  | typeof PATCH_NUMBER
  | typeof VINYL_NUMBER;

export const DEFAULT_PAL_NUMBER = GINNY_NUMBER;

export const PALS: Record<TPalOption, { name: string; image: string }> = {
  [GINNY_NUMBER]: { name: "Ginny", image: GinnyPal },
  [PATCH_NUMBER]: { name: "Patch", image: PatchPal },
  [VINYL_NUMBER]: { name: "Vinyl", image: VinylPal },
};

export const isPalOption = (n: unknown): n is TPalOption =>
  n === GINNY_NUMBER || n === PATCH_NUMBER || n === VINYL_NUMBER;

/** Assigned pal, or Ginny if 0 / missing / invalid. */
export const resolvePal = (n?: number | null) =>
  PALS[isPalOption(n) ? n : DEFAULT_PAL_NUMBER];

export const getPalNumberFromFields = (
  fields?:
    | { slug?: string | null; answer?: { value?: unknown } | null }[]
    | null
): number | undefined => {
  const raw = fields?.find((f) => f.slug === PAL_FIELD_SLUG)?.answer?.value;
  const n = typeof raw === "number" ? raw : Number(raw);
  return Number.isFinite(n) ? n : undefined;
};
